import styled from 'styled-components'

import Grid from '@material-ui/core/Grid'

export const StyledGridContainer = styled(Grid)`
    ${({
        alignItems,
        justifyContent,
        margin,
        padding,
        width,
        $maxWidth,
        height,
    }) => `
    align-items: ${alignItems || 'center'};
    justify-content: ${justifyContent || 'center'};

    width: ${width ? width : '100%'};
    height: ${height ? height : 'auto'};
    margin: ${margin || 0};
    padding: ${padding || 0};

    max-width: ${$maxWidth ? $maxWidth : 'none'};
    
    `}
`

export const StyledGridItem = styled(Grid)`
    ${({ alignItems, justifyContent, margin, padding, width }) => `
    display: flex;
    align-items: ${alignItems || 'center'};
    justify-content: ${justifyContent || 'center'};

    width: ${width ? width : '100%'};
    margin: ${margin || 0};
    padding: ${padding || 0};
    `}
`
